import { NgModule } from '@angular/core';
import { ConfirmComponent } from './confirm/confirm.component';
import { ModalBackdropComponent } from './modal-backdrop/modal-backdrop.component';
import { OverlayContainer, OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { ButtonDropdownModule, ButtonModule, FormElementsModule, ModalDialogLayoutModule } from '@lib/ui';
import { ModalWindowComponent } from './modal-window/modal-window.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CustomOverlayContainer } from './custom-overlay-container';
import { ResizeDirective } from './resize/resize.directive';
import { ResizeTriggerDirective } from './resize/resize-trigger.directive';
import { TranslateModule } from '@project/translate';
import { SingleConfirmComponent } from './single-confirm/single-confirm.component';
import { ModalDropdownComponent } from './modal-options/modal-options.component';
import { FormsModule } from '@angular/forms';
import { DoctorConfirmation } from './doctor-confirmation/doctor-confirmation';

@NgModule({
  declarations: [
    ConfirmComponent,
    DoctorConfirmation,
    ModalBackdropComponent,
    ModalWindowComponent,
    ResizeDirective,
    ResizeTriggerDirective,
    SingleConfirmComponent,
    ModalDropdownComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    OverlayModule,
    FormElementsModule,
    DragDropModule,
    ModalDialogLayoutModule,
    ButtonModule,
    TranslateModule,
    ButtonDropdownModule,
  ],
  exports: [],
  providers: [
    {
      provide: OverlayContainer,
      useClass: CustomOverlayContainer,
    },
  ],
})
export class ModalModule {}
